import {createRouter, createWebHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'


const routes = [
    // 首页
    {
        path: '/',
        name: 'home',
        component: HomeView
    },
    // 客服端
    {
        path: '/service',
        name: 'service',
        component: () => import('../views/serviceView.vue'),

        children: [
            //控制面板
            {
                path: 'service',
                component: () => import('../views/serviceView.vue'),
            },
            //控制面板
            {
                path: '',
                component: () => import('../components/Service/ControlView1.vue'),
            },
            {
                path: 'callData',
                component: () => import('../components/Service/CallData.vue'),
            },
            //客户管理列表
            {
                path: 'clues',
                component: () => import('../components/Service/CluesView.vue'),
            },
            // 销售客户公海
            {
                path: 'sea',
                component: () => import('../components/Service/SeaView.vue'),
            },
            // 销售客户公海 -- 新建用户
            {
                path: 'new',
                component: () => import('../components/Service/SeaNewView.vue'),
            },
            // 我的台账
            {
                path: 'stayCollection',
                component: () => import('../components/Service/stayCollectionView.vue'),
            },
            // 跟进信息
            {
                path: 'flowupInfo',
                component: () => import('../components/Service/FolowupInfomation/tabletitle.vue'),
            },
            // 转调解-主管审核
            {
                path: 'check',
                component: () => import('../components/Service/CheckView.vue'),
            },
            // 转调解-商户主审核
            {
                path: 'merchantCheck',
                component: () => import('../components/Service/MerchantCheckView.vue'),
            },
            // 预调解-审核
            {
                path: 'premediationaudit',
                component: () => import('../components/Service/premediationaudit.vue'),
            },
            // 客情证据审核
            {
                path: 'evidenceReview',
                component: () => import('../components/Service/EvidenceReview.vue'),
            },
            // 审核详情
            {
                path: 'checkdetail',
                component: () => import('../components/CheckElement/CheckDetailView.vue'),
            },
            // 客户详情
            {
                path: 'management',
                name: 'management',
                component: () => import('../components/ManagementElement/ManagementView.vue'),
            },
            // 案件信息
            {
                path: 'casedetail',
                name: 'casedetail',
                component: () => import('../components/RoundElement/CaseDatailView.vue'),
            },
            // 备注跟进
            {
                path: 'remarksFollow',
                name: 'remarksFollow',
                component: () => import('../components/Service/remarksFollow.vue'),
            },
            // 案件管理
            {
                path: 'case',
                component: () => import('../components/Service/CaseView.vue'),
            },

            // 播报设置-播报目标填报
            {
                path: "target",
                component: () => import("../components/BroadcastElement/Target.vue")
            },
            // 播报设置-播报口号设置
            {
                path: "slogan",
                component: () => import("../components/BroadcastElement/Slogan.vue")
            },
            // 播报设置-团队人力填报
            {
                path: "manpower",
                component: () => import("../components/BroadcastElement/Manpower.vue")
            },
            {
                path: "hdvue",
                component: () => import("../components/HDvue.vue")
            },
            // 短信管理 === 发送记录
            {
                path: 'sendMessage',
                component: () => import('../components/MessageElement/SendMessageView.vue'),
            },
            // 短信管理 === 新建发送
            {
                path: 'creatMessage',
                component: () => import('../components/MessageElement/CreatMessageView.vue'),
            },// 短信记录详情
            {
                path: 'msgDetail',
                name: "msgDetail",
                component: () => import('../components/MessageElement/components/msgDetailView.vue'),
            },
            // 菜单管理
            {
                path: "menu_list",
                name: "menu_list",
                component: () => import("../components/Permission/menu/index.vue")
            },
            // 角色管理
            {
                path: "role_list",
                name: "role_list",
                component: () => import("../components/Permission/role/index.vue")
            },
            //组织结构管理
            {
                path: "org_list",
                name: "org_list",
                component: () => import("../components/Permission/org/index.vue")
            },
            //用户管理
            {
                path: "user_list",
                name: "user_list",
                component: () => import("../components/Permission/user/index.vue")
            },
            //分组管理
            {
                path: "group_list",
                name: "group_list",
                component: () => import("../components/Permission/group/index.vue")
            },

            // 系统设置
            // 欠款平台
            {
                path: "bank_platform_list",
                name: "bank_platform_list",
                component: () => import("../components/Config/bankPlatform/index.vue")
            },
            // 一级跟进动作
            {
                path: "follow_action_list",
                name: "follow_action_list",
                component: () => import("../components/Config/followAction/index.vue")
            },
            // 线索来源
            {
                path: "thread_source_list",
                name: "thread_source_list",
                component: () => import("../components/Config/threadSource/index.vue")
            },
            // 流失原因
            {
                path: "scenarion_info_list",
                name: "scenarion_info_list",
                component: () => import("../components/Config/threadScenarionInfo/index.vue")
            },
            // 用户资料
            {
                path: "custom_field_list",
                name: "custom_field_list",
                component: () => import("../components/Config/threadCustomField/index.vue")
            },
            // 短信模板分类
            {
                path: "sms_temp_cate_list",
                name: "sms_temp_cate_list",
                component: () => import("../components/Config/smsTempCategory/index.vue")
            },
            // 短信模板分类
            {
                path: "sms_temp_list",
                name: "sms_temp_list",
                component: () => import("../components/Config/smsTemp/index.vue")
            },
            // 短信模板分类
            {
                path: "robot",
                name: "robot",
                component: () => import("../components/BroadcastElement/robot.vue")
            },
            // 脱敏警告
            {
                path: "desensitize",
                name: "desensitize",
                component: () => import("../components/Desensitize/customer_desensitize_list.vue")
            },
            // 脱敏警告
            {
                path: "login_log_list",
                name: "login_log_list",
                component: () => import("../components/Desensitize/login_log_list.vue")
            },

        ]
    },
    {
        path: '/404',
        name: '/404',
        component: () => import('../views/NotFound.vue')
    },
    {
        path: '/:pathMatch(.*)',
        redirect: "/404"
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router
